import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { finishGoogle } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        finishGoogle(data);
        window.history.replaceState({}, document.title, "/");
        navigate("/");
      } catch (e) {
        setErr(apiError(e));
      }
    })();
  }, [finishGoogle, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950 text-zinc-200">
      <div className="text-center">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-2 border-emerald-500 border-t-transparent" />
        {err ? <p className="text-rose-400">{err}</p> : <p>Signing you in…</p>}
      </div>
    </div>
  );
}
